import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import { type Level } from '@/lib/types';
import { useContext } from 'react';

const usePartProgressValues = (level: Level): [number, number] => {
  const [portfolio] = useContext(RubricsPortfolioContext);

  const progressObject = portfolio.progress[level.partId];

  if (typeof progressObject === 'undefined') {
    return [0, 0];
  }

  return [progressObject.student ?? 0, progressObject.coach ?? 0];
};

export default usePartProgressValues;
